import React from "react";
import ProtectedRoute from "./ProtectedRoute";
import { useScan } from "../contexts/ScanContext";
import { GUEST_SCANS_ENABLED } from "../utils/guestScans";

// A page that also works without logging in, for scanning public repositories. With guest
// scans turned off it behaves exactly like ProtectedRoute.
const GuestAllowedRoute = ({ children }) => {
  const { authChecking } = useScan();

  if (!GUEST_SCANS_ENABLED) {
    return <ProtectedRoute>{children}</ProtectedRoute>;
  }

  if (authChecking) {
    return <div>Loading...</div>;
  }

  return children;
};

export default GuestAllowedRoute;
